import { useState, useEffect, useMemo } from 'react';

import resourceThreeService from '../../../service/resources/resourceThree.service';
import { dataGridPremiumColumns } from '../../../utils/helper';
import { DataGridIdentifiers, OrderArrowsUI, DatagridPremiumUi } from '../../Interface';

export default function ResourceThreeReports({
  refetch,
  values,
  viewField,
  operatorsDisabled,
  autocompleteOptions,
  dynProps,
}) {
  const { refetchTable, setRefetchTable } = refetch;
  const { setSelectedValues } = values;

  const [reports, setReports] = useState({ rows: [], rowCount: 0 });
  const [rowSelectionModel, setRowSelectionModel] = useState([]);

  const initialState = {
    filter: { filterModel: { items: [], logicOperator: 'and' } },
    sorting: {
      sortModel: [{ field: 'name', sort: 'asc' }],
    },
    pagination: {
      paginationModel: {
        pageSize: 25,
        page: 0,
      },
    },
    density: 'compact',
  };

  useEffect(() => {
    if (operatorsDisabled) {
      setRowSelectionModel([]);
    }
  }, [operatorsDisabled]);

  const getList = (gridState) => {
    resourceThreeService.getResources(gridState).then((data) => {
      setReports(data);
      setRefetchTable(false);
    });
  };

  const orderResource = (id, newOrder) => {
    resourceThreeService.orderResource(id, { newOrder }).then(() => {
      setRefetchTable(true);
    });
  };

  const handleOrderChange = (id, direction) => {
    orderResource(id, direction);
  };

  const columns = useMemo(() => {
    return dataGridPremiumColumns([
      {
        field: 'name',
        headerName: 'Név',
        type: 'string',
      },
      {
        field: 'resourceGroup',
        headerName: 'Csoport',
        type: 'singleSelect',
        renderCell: (data) => {
          return data.row.resourceGroup?.itemName;
        },
        valueOptions: autocompleteOptions.resourceGroup,
      },
      {
        field: 'statusId',
        type: 'singleSelect',
        headerName: 'Státusz',
        renderCell: (data) => {
          return data.row.status?.itemName;
        },
        valueOptions: autocompleteOptions.status,
      },
      {
        field: 'typeId',
        type: 'singleSelect',
        headerName: 'Típus',
        renderCell: (data) => {
          return data.type?.itemName;
        },
        sortable: false,
        valueOptions: autocompleteOptions.type,
      },
      {
        field: 'active',
        type: 'boolean',
        headerName: 'Aktív',
        sortable: false,
      },
      {
        field: 'visOrder',
        headerName: 'Sorrend',
        type: 'action',
        filterable: false,
        renderCell: (params) => {
          const disabled = params?.api?.getSortModel()[0]?.field !== 'visOrder';
          const isSortedDescending = params.api.getSortModel()[0]?.sort === 'desc';

          const handleUpClick = () => {
            if (isSortedDescending) {
              handleOrderChange(params.row.id, 'down');
            } else {
              handleOrderChange(params.row.id, 'up');
            }
          };

          const handleDownClick = () => {
            if (isSortedDescending) {
              handleOrderChange(params.row.id, 'up');
            } else {
              handleOrderChange(params.row.id, 'down');
            }
          };

          return <OrderArrowsUI onUpClick={handleUpClick} onDownClick={handleDownClick} disabled={disabled} />;
        },
      },
    ]);
  }, [autocompleteOptions, dynProps]);

  return (
    <DatagridPremiumUi
      datagridIdentifier={DataGridIdentifiers.resourceThree}
      datagridInitialState={initialState}
      dataLoader={getList}
      rows={reports.rows}
      refetch={{ refetchTable, setRefetchTable }}
      rowCount={reports.rowCount}
      columns={[...columns]}
      onRowClick={(rowData) => {
        if (!viewField) return;
        setSelectedValues(rowData.row);
      }}
      paginationAndfilterMode="server"
      onRowSelectionModelChange={(newRowSelectionModel) => {
        setRowSelectionModel(newRowSelectionModel);
      }}
      rowSelectionModel={rowSelectionModel}
      disableRowSelectionOnClick={!viewField}
    />
  );
}
